import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable, Modal } from '~/components';
import {
    recordFiltering,
    findData,
} from '~/store/modules/equipamento/actions';


import { sortBy } from 'lodash';

import MyForm from './form';
import Vazao from './vazao'
import Eletronica from './eletronica'
function Equipamento() {

    const modalVazao = useRef(null)
    const modalEletronica = useRef(null)
    const redux = useSelector((state) => state.equipamento);

    const [selectedItem, setSelectedItem] = useState({})


    const header = useMemo(
        () => [
            { id: 'empe_desc', label: 'Empresa', filter: { type: 'text' } },
            { id: 'veic_cod_veic', label: 'Equipamento', filter: { type: 'text' } },
            { id: 'tive_desc', label: 'Tipo Equipamento', filter: { type: 'text' } },
            { id: 'mode_descricao', label: 'Modelo', filter: { type: 'text' } },
            { id: 'veic_vol_tnq', label: 'Capacidade Tnq' },
            { id: 'vela_num_lacre', label: 'Util. Lacre' },
            { id: 'veva_vazao_maxima', label: 'Vazão Máxima(L/min)' },
            { id: 'veic_transponder1', label: 'Transponder 01' },
            { id: 'veic_transponder2', label: 'Transponder 02' },
            { id: 'veel_tem_a2vf_str', label: 'Tem A2VF' },
            { id: 'veic_st_reg_str', label: 'Ativa' },

        ],
        []
    );

    const buttons = useMemo(() => {
        let arrayButtons = [
            {
                title: 'Vazão',
                icon: <span>Vazão</span>,
                action: (value) => modalVazao.current.handleOpenModal({ data: { ...value } })
            },
        ]

        if (selectedItem.tive_cod_tive == 10) {
            arrayButtons.push({
                title: 'Eletrônica',
                icon: <span>Eletrônica</span>,
                action: (value) => modalEletronica.current.handleOpenModal({ data: { ...value } })
            })
        }

        return sortBy(arrayButtons, 'title')
    }, [selectedItem]);

    const handleSelctItem = useCallback((value) => {
        setSelectedItem(value)
    }, [])

    return (
        <>
            <UnidataTable
                fixed
                header={header}
                read={recordFiltering}
                find={findData}
                redux={redux}
                form={MyForm}
                remove={false}
                actions={buttons}
                title="Equipamentos"
                detach="veic_cod_veic"
                keys={['veic_cod_veic', 'empe_cod_emp']}
                onRow={handleSelctItem}
            />

            <Modal
                ref={modalVazao}
                disableBackdropClick
                disableEscapeKeyDown
                form
                maxWidth="xs"
                title="Cadastro de veículos Vazão"
                component={Vazao}
                labelConfirm="Salvar"
                fullScreen={window.innerWidth <= 425}
            />

            <Modal
                ref={modalEletronica}
                disableBackdropClick
                disableEscapeKeyDown
                form
                maxWidth="md"
                title="Cadastro de veículos A2VF"
                component={Eletronica}
                labelConfirm="Salvar"
                fullScreen={window.innerWidth <= 425}
            />
        </>

    );
}

export default Equipamento;
